// extracted by mini-css-extract-plugin
export default {"from-error":"QuestionnaireForm_from-error__Eqpbf"};